import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClock3OClock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"clock-3-o-clock, time, 3-00"} maskId="square-filled-radius-0-stroke-1-IconClock3OClock"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.5 5.5V12.5H17.5V11.5H12.5V5.5H11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconClock3OClock;
